import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';

import ContentSpinner from '@/components/ContentSpinner';
import { SectionHeading } from '@/components/Layout/Parts';
import { ReleaseResource } from '@/types/resources';
import { api } from '@/utils/api';
import { DistributionDepartmentsEnum, ReleaseStatusEnum } from '@/utils/enums';

import { NoSchedulesText, NoShcedules } from './DistributionList';
import DistributionListItem from './DistributionListItem';

interface Props {
  status: ReleaseStatusEnum;
  activeDepartment: DistributionDepartmentsEnum;
  selectedChannels: number[];
  activeType: null | 0 | 1;
  activeReserved: null | 0 | 1;
}

const DistributionPreparedDraftList: FC<Props> = ({
  status,
  activeDepartment,
  selectedChannels,
  activeType,
  activeReserved,
}) => {
  const distributionListQueryKey = [
    'releases',
    {
      // teamId,
      selectedChannels,
      status,
      activeDepartment,
      activeType,
      activeReserved,
    },
  ];

  const { data: releases, isLoading } = useQuery<ReleaseResource[]>(
    distributionListQueryKey,
    () =>
      api.get<never, ReleaseResource[]>(`/v1/releases`, {
        params: {
          ...(activeType !== null && {
            'filter[isReel]': activeType,
          }),
          ...(activeReserved !== null && {
            'filter[isReserved]': activeReserved,
          }),
          ...(activeDepartment !== DistributionDepartmentsEnum.ALL && {
            'filter[is3rdParty]':
              activeDepartment === DistributionDepartmentsEnum.NATIVE
                ? '0'
                : '1',
          }),
          // ...(teamId !== "all" && {
          //   "filter[teamId]": `${teamId}${
          //     status === ReleaseStatusEnum.DRAFT ? ",null" : ""
          //   }`,
          // }),
          ...(!!selectedChannels.length && {
            'filter[channelId]': selectedChannels.join(','),
          }),
          'filter[status]': status,
        },
      }),
    {
      staleTime: 120 * 1000,
    },
  );

  if (isLoading) {
    return <ContentSpinner />;
  }

  return (
    <>
      <SectionHeading>
        {status === ReleaseStatusEnum.DRAFT ? 'Draft' : 'Prepared'} list
      </SectionHeading>
      {!!releases?.length ? (
        releases.map((release) => (
          <DistributionListItem key={release.id} release={release} />
        ))
      ) : (
        <NoShcedules>
          <NoSchedulesText $type="caption">
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.4616 4.42857H5.53854C5.07122 4.42857 4.69238 4.81233 4.69238 5.28572V22.4286C4.69238 22.902 5.07122 23.2857 5.53854 23.2857H22.4616C22.9289 23.2857 23.3078 22.902 23.3078 22.4286V5.28572C23.3078 4.81233 22.9289 4.42857 22.4616 4.42857Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M19.0767 2.71428V6.14285"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.92285 2.71428V6.14285"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.69238 9.57143H23.3078"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            No schedules
          </NoSchedulesText>
        </NoShcedules>
      )}
    </>
  );
};

export default DistributionPreparedDraftList;
